<template>
  <div id="layout-static" class="min-h-100dvh bg-gray-20">
    <navbar class="sticky top-0 w-full" />
    <static-tabs-bar v-if="!isMenuShown" :pages="PAGES" />
    <main class="container relative md:flex mx-auto md:py-10 md:gap-6">
      <static-menu v-if="isMenuShown" :pages="PAGES" />
      <slot class="page-content"></slot>
    </main>
    <addendum />

    <lazy-login-modal />
  </div>
</template>

<script lang="ts" setup>
import Addendum from '@/components/common/addendum.vue'
import Navbar from '@/components/navbar/navbar.vue'
import LazyLoginModal from '@/components/login/lazy-login-modal.vue'
import StaticMenu from '@/components/common/static-menu.vue'
import StaticTabsBar from '@/components/common/static-tabs-bar.vue'

import { useAppStore } from '@/store/app'

const appStore = useAppStore()

const PAGES = [
  { key: 'about-us', title: 'static.about_us.title' },
  { key: 'terms-of-use', title: 'static.terms_of_use.title' },
  { key: 'privacy-policy', title: 'static.privacy_policy.title' },
  { key: 'fair-user-policy', title: 'static.fair_user_policy.title' },
]

const isMenuShown = computed(() => appStore.isDesktopScreen)
</script>

<style lang="scss">
@use '@/assets/styles/_article.scss';
</style>
